// 年卡价值状态枚举（价值差额单位：元，三态：用超/临界/未用超）
// 价值差额 = 实付金额 − 使用次数 × 75 元（次卡等值），为机会成本估算而非现金盈亏。
// 边界与后端 CardService::YEARLY_PROFIT_BREAKEVEN_BOUND 保持一致：
// 用超 < -500 ≤ 临界 ≤ 500 < 未用超
// 标签颜色遵循系统收支惯例：未用超（对公司有利）= 红（tagType danger），用超 = 绿（tagType success）
export const yearlyCardProfitStates = {
  loss: {
    value: 2,
    name: '用超',
    tagType: 'success',
  },
  breakeven: {
    value: 3,
    name: '临界',
    tagType: 'info',
  },
  profit: {
    value: 4,
    name: '未用超',
    tagType: 'danger',
  },
};

// 按盈亏金额（元）查找所属状态
export function findYearlyCardProfitState(profitYuan) {
  if (profitYuan < -500) return [yearlyCardProfitStates.loss];
  if (profitYuan <= 500) return [yearlyCardProfitStates.breakeven];
  return [yearlyCardProfitStates.profit];
}

// 按状态值查找（筛选下拉回显等场景）
export function findYearlyCardProfitStateByValue(value) {
  for (const key in yearlyCardProfitStates) {
    if (value === yearlyCardProfitStates[key].value) return [yearlyCardProfitStates[key]];
  }
  return [];
}
